import React from 'react';
import { Box } from '@mui/material';
import useFeaturedIconStyles from './useFeaturedIconStyles';
import { FeaturedIconProps } from './types';

function FeaturedIcon({
  icon,
  size = 'sm',
  variant = 'Brand',
  type = 'Light',
  className,
  'data-testid': dataTestId,
}: Readonly<FeaturedIconProps>): JSX.Element {
  const styles = useFeaturedIconStyles({ size, variant, type });

  return (
    <Box className={className} data-testid={dataTestId} sx={styles.container}>
      {icon && <Box sx={styles.iconContainer}>{icon}</Box>}
      <Box sx={styles.border} />
    </Box>
  );
}

export default FeaturedIcon;
